var _g, _path, _path2, _path3, _path4, _path5, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg404(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 395,
    height: 175,
    viewBox: "0 0 395 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.9858 160H58.116V134.859H0V114.454L48.2782 38.4844H83.9858V112.086H99.6535V134.859H83.9858V160ZM58.116 112.086V61.4393L25.3233 112.086H58.116Z",
    fill: "#1C1D23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.142 160H353.272V134.859H295.156V114.454L343.434 38.4844H379.142V112.086H394.809V134.859H379.142V160ZM353.272 112.086V61.4393L320.479 112.086H353.272Z",
    fill: "#1C1D23"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M148.024 5.13951C148.024 18.5867 147.969 75.7831 148.024 89.2303C148.024 89.2303 160.467 108.621 204.586 108.621C248.704 108.621 261.147 89.2303 261.147 89.2303V5.65068C261.147 3.33084 260.843 1.33865 258.212 0.342565C255.47 -0.679736 253.954 0.879923 252.397 2.57065C247.547 7.82634 242.683 13.0689 237.489 18.6785C233.452 13.4228 229.649 8.46856 225.846 3.52743C222.25 -1.13846 219.494 -1.15157 215.981 3.46189C212.315 8.27197 208.664 13.0951 204.847 18.128C200.755 12.964 196.801 7.99674 192.86 3.01628C189.65 -1.03361 187.307 -1.0074 184.097 3.10802C180.129 8.19333 176.147 13.2655 171.958 18.626C167.397 13.816 162.974 9.15009 158.537 4.4711C157.807 3.6978 157.077 2.92454 156.361 2.13815C154.886 0.526057 153.219 -0.404506 150.863 0.368775C148.397 1.18137 148.024 3.04249 148.024 5.13951Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M148.024 5.13951C148.024 18.5867 147.969 75.7831 148.024 89.2303C148.024 89.2303 160.467 108.621 204.586 108.621C248.704 108.621 261.147 89.2303 261.147 89.2303V5.65068C261.147 3.33084 260.843 1.33865 258.212 0.342565C255.47 -0.679736 253.954 0.879923 252.397 2.57065C247.547 7.82634 242.683 13.0689 237.489 18.6785C233.452 13.4228 229.649 8.46856 225.846 3.52743C222.25 -1.13846 219.494 -1.15157 215.981 3.46189C212.315 8.27197 208.664 13.0951 204.847 18.128C200.755 12.964 196.801 7.99674 192.86 3.01628C189.65 -1.03361 187.307 -1.0074 184.097 3.10802C180.129 8.19333 176.147 13.2655 171.958 18.626C167.397 13.816 162.974 9.15009 158.537 4.4711C157.807 3.6978 157.077 2.92454 156.361 2.13815C154.886 0.526057 153.219 -0.404506 150.863 0.368775C148.397 1.18137 148.024 3.04249 148.024 5.13951Z",
    fill: "url(#paint0_linear_354_3373)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M185.724 174.983C180.966 168.406 176.5 162.235 172.035 156.064C168.743 151.521 165.499 151.326 161.686 155.494C157.399 160.183 153.162 164.905 148.55 169.985C148.371 168.812 148.159 168.096 148.159 167.363C148.159 142.306 147.686 117.232 148.371 92.1909C148.974 69.8036 159.844 52.594 179.108 41.4735C201.419 28.5949 229.434 34.603 246.546 55.0037C256.227 66.531 261.116 79.817 261.132 94.8449C261.165 118.486 261.132 142.143 261.132 165.784C261.132 166.908 261.132 168.031 261.132 170.017C256.422 164.693 252.348 160.037 248.209 155.445C244.379 151.196 241.38 151.359 237.974 155.999C233.378 162.219 228.799 168.47 223.991 174.999C219.281 168.601 214.799 162.447 210.268 156.308C206.487 151.18 203.244 151.212 199.463 156.357C194.998 162.414 190.532 168.47 185.724 174.983Z",
    fill: "#1C1D23"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M185.724 174.983C180.966 168.406 176.5 162.235 172.035 156.064C168.743 151.521 165.499 151.326 161.686 155.494C157.399 160.183 153.162 164.905 148.55 169.985C148.371 168.812 148.159 168.096 148.159 167.363C148.159 142.306 147.686 117.232 148.371 92.1909C148.974 69.8036 159.844 52.594 179.108 41.4735C201.419 28.5949 229.434 34.603 246.546 55.0037C256.227 66.531 261.116 79.817 261.132 94.8449C261.165 118.486 261.132 142.143 261.132 165.784C261.132 166.908 261.132 168.031 261.132 170.017C256.422 164.693 252.348 160.037 248.209 155.445C244.379 151.196 241.38 151.359 237.974 155.999C233.378 162.219 228.799 168.47 223.991 174.999C219.281 168.601 214.799 162.447 210.268 156.308C206.487 151.18 203.244 151.212 199.463 156.357C194.998 162.414 190.532 168.47 185.724 174.983Z",
    fill: "url(#paint1_radial_354_3373)",
    fillOpacity: 0.9
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M185.724 174.983C180.966 168.406 176.5 162.235 172.035 156.064C168.743 151.521 165.499 151.326 161.686 155.494C157.399 160.183 153.162 164.905 148.55 169.985C148.371 168.812 148.159 168.096 148.159 167.363C148.159 142.306 147.686 117.232 148.371 92.1909C148.974 69.8036 159.844 52.594 179.108 41.4735C201.419 28.5949 229.434 34.603 246.546 55.0037C256.227 66.531 261.116 79.817 261.132 94.8449C261.165 118.486 261.132 142.143 261.132 165.784C261.132 166.908 261.132 168.031 261.132 170.017C256.422 164.693 252.348 160.037 248.209 155.445C244.379 151.196 241.38 151.359 237.974 155.999C233.378 162.219 228.799 168.47 223.991 174.999C219.281 168.601 214.799 162.447 210.268 156.308C206.487 151.18 203.244 151.212 199.463 156.357C194.998 162.414 190.532 168.47 185.724 174.983Z",
    fill: "url(#paint2_radial_354_3373)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15,
    filter: "url(#filter0_di_354_3373)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188.876 89.6104L193.338 85.1485C194.101 84.3856 194.494 83.3802 194.494 82.3744C194.494 81.3687 194.112 80.363 193.338 79.6003C191.8 78.0629 189.315 78.0629 187.778 79.6003L183.316 84.0619L178.854 79.6003C177.317 78.0629 174.831 78.0629 173.294 79.6003C172.531 80.363 172.138 81.3687 172.138 82.3744C172.138 83.3802 172.52 84.3856 173.294 85.1485L177.756 89.6104L173.294 94.0723C172.531 94.8352 172.138 95.8409 172.138 96.8464C172.138 97.8521 172.52 98.8578 173.294 99.6208C174.069 100.383 175.063 100.777 176.068 100.777C177.074 100.777 178.08 100.395 178.843 99.6208L183.305 95.1589L187.766 99.6208C188.529 100.383 189.535 100.777 190.54 100.777C191.546 100.777 192.552 100.395 193.315 99.6208C194.078 98.8463 194.47 97.8521 194.47 96.8464C194.47 95.8409 194.089 94.8352 193.315 94.0723L188.853 89.6104H188.876Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15,
    filter: "url(#filter1_di_354_3373)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.626 89.6104L237.088 85.1485C237.851 84.3856 238.244 83.3802 238.244 82.3744C238.244 81.3687 237.862 80.363 237.088 79.6003C235.55 78.0629 233.065 78.0629 231.528 79.6003L227.066 84.0619L222.604 79.6003C221.067 78.0629 218.582 78.0629 217.044 79.6003C216.281 80.363 215.888 81.3687 215.888 82.3744C215.888 83.3802 216.27 84.3856 217.044 85.1485L221.506 89.6104L217.044 94.0723C216.281 94.8352 215.888 95.8409 215.888 96.8464C215.888 97.8521 216.27 98.8578 217.044 99.6208C217.819 100.383 218.813 100.777 219.819 100.777C220.824 100.777 221.83 100.395 222.593 99.6208L227.055 95.1589L231.516 99.6208C232.279 100.383 233.285 100.777 234.29 100.777C235.296 100.777 236.302 100.395 237.065 99.6208C237.828 98.8463 238.221 97.8521 238.221 96.8464C238.221 95.8409 237.839 94.8352 237.065 94.0723L232.603 89.6104H232.626Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_354_3373",
    x: 163.086,
    y: 73.9214,
    width: 40.459,
    height: 40.4326,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.52588
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.52588
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.49 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_354_3373"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_354_3373",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3.01725,
    dy: -3.01725
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.01725
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_354_3373"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_di_354_3373",
    x: 206.837,
    y: 73.9214,
    width: 40.459,
    height: 40.4326,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.52588
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.52588
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.49 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_354_3373"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_354_3373",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3.01725,
    dy: -3.01725
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.01725
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_354_3373"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_354_3373",
    x1: 182.095,
    y1: 103,
    x2: 318.986,
    y2: -32.858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E46223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.587785,
    stopColor: "#E46223",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E46223",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_354_3373",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(236.255 51.2921) rotate(113.085) scale(50.0184 52.1025)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1D23",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_354_3373",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(175.155 174.999) rotate(-61.2324) scale(87.7729 91.4302)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.f97b143213381fb26264239f7d964628.svg";
export { ForwardRef as ReactComponent };